/**
 * Label PDF API client.
 * Provides URL builders for PDF label sheet generation.
 */

const API_BASE = '/api/v1';

export type PageFormat = 'a4' | 'letter';
export type LabelSize = 'small' | 'medium' | 'large';

/**
 * Get the URL for a label sheet PDF.
 * Use this URL in an anchor tag or window.open() to download the PDF.
 *
 * @param markerIds - Array of marker specs like ["aruco:5", "qr:winter-clothes"]
 * @param format - Page format: "a4" or "letter" (default "a4")
 * @param labelSize - Label size: "small", "medium", or "large" (default "medium")
 * @returns URL string for the PDF endpoint
 */
export function getLabelsPdfUrl(
  markerIds: string[],
  format?: PageFormat,
  labelSize?: LabelSize,
): string {
  const params = new URLSearchParams();
  params.set('markerIds', markerIds.join(','));
  if (format) params.set('format', format);
  if (labelSize) params.set('labelSize', labelSize);
  return `${API_BASE}/labels/pdf?${params.toString()}`;
}
